import { useLanguage } from "contexts/language.context";
import { INTERNAL } from "const";
import { NestedDropdown } from "mui-nested-menu";

export default function AuditsConsolidatedReportGenerateAction({
  data,
  disabled,
  onSelect,
}) {
  const { label } = useLanguage();
  const branchGroup = data.newBranchGroup;
  const selected = data.originalSelected || [];
  const branches = branchGroup?.branches || [];
  const selectedBranches = branches.filter(
    (_, index) => selected[index]?.length,
  );
  const regions = [
    ...new Map(
      branches.map((branch) => [branch.region.id, branch.region]),
    ).values(),
  ];
  let allowComparative = selectedBranches.length > 0;
  selectedBranches.forEach((branch) => {
    const index = branches.findIndex((item) => item.id === branch.id);
    const audits = selected[index]
      .map((id) => branch.audits.find((audit) => audit.id === id))
      .filter(Boolean);
    if (
      audits.filter((audit) => audit.type === INTERNAL).length !== 1 ||
      audits.filter((audit) => audit.type !== INTERNAL).length !== 1
    )
      allowComparative = false;
  });
  const setReportType = (auditsReport) => {
    if (!disabled) onSelect(auditsReport);
  };
  const options = [
    {
      label: label("generate-all-button"),
      sx: { mx: -1 },
      callback: () => setReportType({ value: "normal" }),
    },
    {
      label: label("generate-comparative-button"),
      sx: { mx: -1 },
      disabled: !allowComparative,
      callback: () => setReportType({ value: "comparative" }),
    },
    {
      label: label("generate-by-region-button"),
      sx: { mx: -1 },
      items: regions.map((region) => ({
        label: region.description,
        sx: {
          "& .MuiBox-root": {
            "& .MuiTypography-root": { fontSize: "14px" },
          },
          mx: -1,
        },
        disabled: !selectedBranches.some(
          (branch) => branch.region.id === region.id,
        ),
        callback: () => setReportType({ value: "region", region }),
      })),
    },
    {
      label: label("generate-comprehensive"),
      sx: { mx: -1 },
      disabled: !data.reportAreas?.some((area) =>
        selectedBranches.some((branch) => branch.areaId == area.id),
      ),
      callback: () =>
        setReportType({ value: "comprehensive", areas: data.reportAreas }),
    },
  ];

  return (
    <NestedDropdown
      ButtonProps={{
        type: "button",
        sx: {
          backgroundColor: "info.main",
          color: "white !important",
          "&:hover": {
            backgroundColor: "info.main",
            color: "white !important",
            opacity: 0.5,
          },
        },
        disabled,
      }}
      MenuProps={{
        sx: {
          "& .MuiBox-root": {
            "& .MuiTypography-root": { fontSize: "14px" },
          },
        },
      }}
      menuItemsData={{
        label: label("generate-button"),
        items: options,
      }}
    />
  );
}
